/**
 * 3. geçiş — kenar taraması (tam çözünürlük, isteğe bağlı).
 *
 * Yalnız doldurma geçişinde hiçbir komşu noktası tutmayan pikseller taranır
 * (ince parçalar, keskin kenarlar). Diğer pikseller ilk satırda atılır (Discard),
 * bu yüzden düz alanlarda neredeyse bedava. Engebeli yerde ışın sıklaşır, düz yerde seyrek kalır.
 *
 * Çıktı: vec4( gi.rgb, ao ). Atılan piksellerde eski değer kalır; geçmiş geçişi
 * bu dokuyu yalnız doldurmada NO_DATA olan piksellerde okur.
 */

import { Discard, Fn, If, floor, uv } from 'three/tsl';
import { buildHorizonTrace } from './horizonTrace.js';

export function buildRefinePass( node ) {

	const traceGiAo = buildHorizonTrace( node );

	return Fn( () => {

		const screenUv = uv();
		const filled = node._fillTexture.sample( screenUv );

		If( filled.a.greaterThanEqual( 0 ), () => {

			Discard();

		} );

		const pixelCenter = floor( screenUv.mul( node._fullResolution ) ).add( 0.5 );

		return traceGiAo( screenUv, pixelCenter );

	} )();

}
